var _excluded = ["backgroundColor", "borderColor", "borderStartColor", "borderEndColor", "borderTopColor", "borderBottomColor", "borderXColor", "borderYColor", "UNSAFE_style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, useMemo } from 'react';
import { useLocale, View as SpectrumView } from '@adobe/react-spectrum';
import { colorValueStyle } from "../theme/colorUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A View component that re-exports the Spectrum View component.
 * However, it overrides ColorValues to accept CSS color strings and
 * our custom variable names from our color palette and semantic colors.
 *
 * @param props The props for the View component
 * @returns The View component
 *
 */
export var View = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  var backgroundColor = props.backgroundColor,
    borderColor = props.borderColor,
    borderStartColor = props.borderStartColor,
    borderEndColor = props.borderEndColor,
    borderTopColor = props.borderTopColor,
    borderBottomColor = props.borderBottomColor,
    borderXColor = props.borderXColor,
    borderYColor = props.borderYColor,
    UNSAFE_style = props.UNSAFE_style,
    rest = _objectWithoutProperties(props, _excluded);
  var _useLocale = useLocale(),
    direction = _useLocale.direction;
  var style = useMemo(() => {
    var borderStyle = {};
    if (borderColor !== undefined) {
      borderStyle.borderColor = colorValueStyle(borderColor);
    }
    if (borderXColor !== undefined) {
      borderStyle.borderLeftColor = colorValueStyle(borderXColor);
      borderStyle.borderRightColor = colorValueStyle(borderXColor);
    }
    if (borderYColor !== undefined) {
      borderStyle.borderTopColor = colorValueStyle(borderYColor);
      borderStyle.borderBottomColor = colorValueStyle(borderYColor);
    }
    if (borderStartColor !== undefined) {
      borderStyle[direction === 'rtl' ? 'borderRightColor' : 'borderLeftColor'] = colorValueStyle(borderStartColor);
    }
    if (borderEndColor !== undefined) {
      borderStyle[direction === 'rtl' ? 'borderLeftColor' : 'borderRightColor'] = colorValueStyle(borderEndColor);
    }
    if (borderTopColor !== undefined) {
      borderStyle.borderTopColor = colorValueStyle(borderTopColor);
    }
    if (borderBottomColor !== undefined) {
      borderStyle.borderBottomColor = colorValueStyle(borderBottomColor);
    }
    return _objectSpread(_objectSpread({}, UNSAFE_style), {}, {
      backgroundColor: colorValueStyle(backgroundColor)
    }, borderStyle);
  }, [backgroundColor, UNSAFE_style, borderColor, borderStartColor, borderEndColor, borderTopColor, borderBottomColor, borderXColor, borderYColor, direction]);
  return /*#__PURE__*/_jsx(SpectrumView, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    UNSAFE_style: style
  }));
});
View.displayName = 'View';
export default View;
//# sourceMappingURL=View.js.map